// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UQaXr","label":"styles_label__3k4dk"};